/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const EnumHelper = (data: any = {}) => {
  return Object.keys(data).map((value) => ({
    id: data[value],
    name: value
      .toLowerCase()
      .replaceAll("_", " ")
      .replace(/\b[a-z]/g, (text) => text.toUpperCase()),
  }));
};
export const JobTypeEnum = {
  CONTRACT: 1,
  INTERNSHIP: 2,
  PART_TIME: 3,
  FREELANCE: 4,
  FULL_TIME: 5,
  VOLUNTEER: 6,
};
export const JobInterviewTypeEnum = {
  OFFLINE: 1,
  ONLINE: 2,
  ONSITE: 3,
};
export const LanguageLevelEnum = {
  BASIC: 1,
  INTERMEDIATE: 2,
  ADVANCE: 3,
  NATIVE: 4,
};
export const AdminJobFairTypeEnum = {
  SCHOOL: 1,
  ORGANIZATION: 2,
  SCHOOL_INTERNAL: 3,
  COMPANY: 4,
};
export const AdminJobFairAuthorizationEnum = {
  REGISTER: 1,
  LOGIN: 2,
  AUTO_LOGIN: 3,
  STATISTICS: 4,
  AUTO_CHANGE_PIN: 5,
  COMPANY_REGISTER: 6,
};
export const AdminJobFairJobApplicantStatusEnum = {
  PENDING: 1,
  IN_REVIEW: 2,
  INVITED: 3,
  REJECTED: 4,
  APPROVED: 5,
};
export const AdminJobFairPartnerGroupSizeEnum = {
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
};
export const AdminJobFairTransactionCategoryEnum = {
  ALUMNI: 1,
  ACTIVE: 2,
  GENERAL: 3,
};
export const AdminJobFairOrganizerUserAuthorizationEnum = {
  APPLICANT_LIST: 1,
  COMPANY_LIST: 2,
  METRICS: 3,
  QR: 4,
};
export const AdminJobFairJobQuestionTypeEnum = {
  SHORT_TEXT: 1,
  LONG_TEXT: 2,
  MULTIPLE_CHOICES: 3,
  CHECKBOX: 4,
  DROPDOWN: 5,
  FILE: 6,
  SCALE: 7,
};

export const AdminJobFairTodoStatusEnum = {
  COPY_SHARE: 1,
  DOWNLOAD_QR_REGISTRATION: 2,
  DOWNLOAD_QR_COMPANY: 3,
  QUOTA_COMPANY: 4,
};
export const NotificationTypeEnum = {
  BROADCAST: 1,
  PARTNERSHIP: 2,
  CANDIDATE: 3,
  TRACER_STUDY: 4,
  ADMIN_JOB_FAIR: 5,
  ADMIN_JOB_FAIR_JOB: 6,
  ADMIN_JOB_FAIR_JOB_APPLICATION: 7,
  JOB_APPLICATION: 8,
  SCHOOL_EVENT: 9,
  SCHOOL_SUBSCRIPTION: 10,
  SCHOOL_VERIFICATION: 11,
};